import { createAction, handleActions } from "redux-actions";
import ActionTypes from "~shared/constants/actionTypes";
import { _getTimeZoneList, _setTimeZoneList } from "~shared/httpService/apis";

const initialState = {
  time_zone_list: { loading: false, response: [], hasError: false, error: {} },
  set_time_zone: { loading: false, response: [], hasError: false, error: {} },
};

const getTimeZoneList = createAction(ActionTypes.GET_TIME_ZONE_LIST);
const getTimeZoneListSuccess = createAction(
  ActionTypes.GET_TIME_ZONE_LIST_SUCCESS,
  (response) => response
);
const getTimeZoneListError = createAction(
  ActionTypes.GET_TIME_ZONE_LIST_ERROR,
  (error) => error
);
const setTimeZone = createAction(ActionTypes.SET_TIME_ZONE);
const setTimeZoneSuccess = createAction(
  ActionTypes.SET_TIME_ZONE_SUCCESS,
  (response) => response
);
const setTimeZoneError = createAction(
  ActionTypes.SET_TIME_ZONE_ERROR,
  (error) => error
);
export const fetchTimeZone = (schemaName) => (dispatch) => {
  dispatch(getTimeZoneList());
  return _getTimeZoneList(schemaName)
    .then((response) => {
      dispatch(getTimeZoneListSuccess(response));
    })
    .catch((error) => {
      dispatch(getTimeZoneListError(error));
    });
};

export const setStoreTimeZone = (schemaName, storeId) => (dispatch) => {
  dispatch(setTimeZone());
  return _setTimeZoneList(schemaName, storeId)
    .then((response) => {
      dispatch(setTimeZoneSuccess(response));
    })
    .catch((error) => {
      dispatch(setTimeZoneError(error));
    });
};

const reducer = handleActions(
  {
    // Get time zone list

    [ActionTypes.GET_TIME_ZONE_LIST]: (state) => ({
      ...state,
      time_zone_list: {
        ...state.time_zone_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_TIME_ZONE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      time_zone_list: {
        ...state.time_zone_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_TIME_ZONE_LIST_ERROR]: (state, action) => ({
      ...state,
      time_zone_list: {
        ...state.time_zone_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    [ActionTypes.SET_TIME_ZONE]: (state) => ({
      ...state,
      set_time_zone: {
        ...state.set_time_zone,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.SET_TIME_ZONE_SUCCESS]: (state, action) => ({
      ...state,
      set_time_zone: {
        ...state.set_time_zone,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_TIME_ZONE_LIST_ERROR]: (state, action) => ({
      ...state,
      set_time_zone: {
        ...state.set_time_zone,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
  },
  initialState
);
export default reducer;
